import PropTypes from 'prop-types';
import { useState } from 'react';
import styled, { css } from 'styled-components';
import VizExLoadingButton from 'visitor-ui-component-library/button/VizExLoadingButton';
import VizExButton from 'visitor-ui-component-library/button/VizExButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CIRRUS, NEUTRAL_200, NEUTRAL_600, NEUTRAL_800, WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import { ChatWidgetLocaleContextConsumer } from './ChatWidgetLocaleContext';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import VizExCloseButton from 'visitor-ui-component-library/button/VizExCloseButton';
import { createThemeV2 } from 'visitor-ui-component-library/theme/createThemeV2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "ConsentPrompt__Container"
})(["", " display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;padding:12px 28px;position:relative;background:", ";"], props => props.$isOutsideChat ? css(["border:1px solid ", ";"], NEUTRAL_600) : css(["border-top:2px solid ", ";"], CIRRUS), NEUTRAL_200);
const SmallNoParagraphPadding = styled(VizExSmall).withConfig({
  displayName: "ConsentPrompt__SmallNoParagraphPadding"
})(["display:block;line-height:24px;word-break:break-word;word-wrap:break-word;-ms-word-break:break-all;p{margin-bottom:0;}"]);
const FullWidthButton = styled(VizExButton).withConfig({
  displayName: "ConsentPrompt__FullWidthButton"
})(["margin:0 auto;width:fit-content;flex:0 0 auto;border-radius:999px;&:focus-visible{outline:2px solid ", ";outline-offset:-4px;}"], WHITE);
const FlexWrapper = styled.div.withConfig({
  displayName: "ConsentPrompt__FlexWrapper"
})(["display:flex;flex-direction:row;width:100%;margin:12px 0 8px 0;"]);
const ConsentPrompt = ({
  message,
  onClick,
  onClose = () => {},
  showButton,
  isPortal53 = false,
  isOutsideChat = false
}) => {
  const [submitting, setSubmitting] = useState(false);
  const onClickWrapper = () => {
    onClick();
    setSubmitting(true);
  };
  return /*#__PURE__*/_jsxs(Container, {
    "data-test-id": "gdpr-consent-prompt",
    dir: "auto",
    $isOutsideChat: isOutsideChat,
    className: !(showButton || isOutsideChat) ? 'm-bottom-4' : undefined,
    children: [!showButton && isPortal53 && /*#__PURE__*/_jsx(VizExCloseButton, {
      size: 'sm',
      onClick: onClose,
      theme: isOutsideChat ? createThemeV2({
        colors: {
          text: NEUTRAL_800
        }
      }) : createThemeV2()
    }), /*#__PURE__*/_jsx(SmallNoParagraphPadding, {
      use: "help",
      "data-test-id": "gdpr-consent-text",
      dangerouslySetInnerHTML: {
        __html: formatHtml(message)
      }
    }), showButton && /*#__PURE__*/_jsx(FlexWrapper, {
      children: /*#__PURE__*/_jsx(VizExLoadingButton, {
        currentState: submitting ? 'submitting' : 'ready',
        Button: FullWidthButton,
        "data-test-id": "gdpr-consent-agree-button",
        onClick: onClickWrapper,
        children: /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
          children: locale => /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-visitor-experience-components.buttons.agree",
            options: {
              locale
            }
          })
        })
      })
    })]
  });
};
ConsentPrompt.propTypes = {
  checkboxLabel: PropTypes.string,
  isOutsideChat: PropTypes.bool,
  isPortal53: PropTypes.bool,
  message: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  showButton: PropTypes.bool.isRequired
};
ConsentPrompt.displayName = 'ConsentPrompt';
export default ConsentPrompt;